import { configureStore } from "@reduxjs/toolkit";
import { bookRed } from "../reducers/BookKeepreSlice";
import { users } from "../reducers/userListSlice";
import invoiceSlice from "../reducers/invoiceSlice";
import sentimentSlice from "../reducers/sentimentSlice";
import favDashboardSlice from "../reducers/favDashboardSlice";


export const store = configureStore({
    reducer: {
        bookRed,
        users,
        invoices: invoiceSlice.reducer,
        sentiment: sentimentSlice.reducer,
        favDashboard: favDashboardSlice.reducer,
    }
})